/* unplugin-vue-components disabled */import { render } from "./RoleCard.vue?vue&type=template&id=717c494f&scoped=true"
import script from "./RoleCard.vue?vue&type=script&lang=js"
export * from "./RoleCard.vue?vue&type=script&lang=js"

import "./RoleCard.vue?vue&type=style&index=0&id=717c494f&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户广西-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-717c494f"]])

export default __exports__